import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import AuthContext from 'contexte/AuthContext'
import { fetchFeesSchedule } from 'services/feesServices'
import FeesSchedule from './FeesSchedule'
import FeesSimulator from './FeesSimulator'
import './fees.css'

// Section Frais : la grille en vigueur et un simulateur. Tout est calculé par le fees-manager (lecture seule).
const Fees = () => {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const [tab, setTab] = useState('schedule')
  const [schedule, setSchedule] = useState(null)
  const [error, setError] = useState(null)

  const load = async () => {
    setError(null)
    try {
      setSchedule(await fetchFeesSchedule(user))
    } catch (e) {
      setError(e.response?.data?.error || 'fees_service_unavailable')
    }
  }

  useEffect(() => { load() }, [])

  return (
    <DashboardLayout page={t('pages_name.fees')}>
      <div className='fees_page'>
        <div className='fees_header'>
          <div>
            <h1>{t('pages.fees.title')}</h1>
            <p className='fees_subtitle'>{t('pages.fees.subtitle')}</p>
          </div>
          <div className='fees_tabs' role='tablist'>
            {['schedule', 'simulator'].map(key => (
              <button key={key} role='tab' aria-selected={tab === key}
                className={`fees_tab ${tab === key ? 'fees_tab_active' : ''}`} onClick={() => setTab(key)}>
                {t(`pages.fees.tabs.${key}`)}
              </button>
            ))}
          </div>
        </div>

        {error && (
          <div className='fees_error'>
            {t('pages.fees.load_error')} ({error})
            <button className='fees_link_button' onClick={load}>{t('pages.fees.retry')}</button>
          </div>
        )}
        {!schedule && !error && <div className='fees_loading'>{t('pages.fees.loading')}</div>}

        {schedule && tab === 'schedule' && <FeesSchedule schedule={schedule} />}
        {schedule && tab === 'simulator' && <FeesSimulator schedule={schedule} />}
      </div>
    </DashboardLayout>
  )
}

export default Fees
